/*
 *
 * CallUsModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Jan-2025
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import componentConfig from '../../modules/componentConfig'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import { CallConnecting } from '@nexidigital/iconlibrary'
import './CallUsModal.scss'
import { nullSafe } from 'Utility/globalMethods'

const CallUsModal = (props) => {
  const nexiSupportNumber = '+39 02345448'
  const ispSupportNumber = '+39 028913753'
  const uciSupportNumber = '800 900 280'
  const navigate = useNavigate()
  const showCallUsSectionNB = nullSafe(() => componentConfig.callUs.viewProps.isVisible(), false)
  const showSupportPhone = nullSafe(() => componentConfig.callUs.supportPhone.isVisible(), false)
  const sourceTypeList = nullSafe(() => props.currentInfo?.sourceTypeList, [])
  const hasAcquiringISP = Array.isArray(sourceTypeList) && sourceTypeList.some(type => type === 'ACQUIRING_ISP')
  const supportNumber = showSupportPhone
    ? props.currentInfo.supportPhone || uciSupportNumber
    : hasAcquiringISP
      ? ispSupportNumber
      : nexiSupportNumber

  const handlePrimaryAction = () => {
    window.location.href = `tel:${supportNumber}`
  }

  const handleSecondaryAction = () => {
    props.actions.doHidePopup()
    navigate('/support')
  }

  return (
    <Toggle>
      <MerchantModal
        topBarTitle={showCallUsSectionNB ? formattedMessage.callUsCTANB : formattedMessage.callUs}
        onClose={
          showCallUsSectionNB
            ? null
            : () => {
                props.actions.doHidePopup()
                navigate('/support')
              }
        }
        primaryAction={handlePrimaryAction}
        primaryButtonLabel={formattedMessage.callUsCTA}
        secondaryButtonLabel={showCallUsSectionNB && formattedMessage.goToAssistance}
        secondaryAction={showCallUsSectionNB && handleSecondaryAction}
        primaryIcon={<CallConnecting size='20' type='line' />}
        customAnalyticsDescription={formattedMessage.contactHoursOperatorInfo}
      >
        {
          showCallUsSectionNB
            ? (
              <div className='callUsModal'>
                <div className='callUsModalDetail'>
                  <DataRow
                    full
                    label={formattedMessage.vatLabelNB}
                    content={
                      props.currentInfo.vatNumber
                        ? props.currentInfo.vatNumber
                        : props.currentInfo.fiscalCode
                          ? props.currentInfo.fiscalCode
                          : ''
                    }
                  />
                  <DataRow
                    full
                    label={formattedMessage.shopName}
                    content={props.currentInfo.shopName}
                  />
                  <DataRow
                    full
                    label={formattedMessage.terminalLabel}
                    content={props.currentInfo.terminal}
                  />
                </div>
                <div className='callUsContactNumbers'>
                  <p className='callUsContactLabel'>{formattedMessage.contactLabel}</p>
                  <p className='callUsContactNumber'>{supportNumber}</p>
                  <div className='callUcContacts'>
                    <p>{formattedMessage.contactHoursOperatorInfo}</p>
                    <p>{formattedMessage.footerNBShowPIVA}</p>
                  </div>
                </div>
              </div>
              )
            : (
              <div className='callUsModal'>
                <div className='callUsModalDetail'>
                  <DataRow full label={formattedMessage.shopName} content={props.currentInfo.shopName} />
                  <DataRow
                    full
                    label={formattedMessage.shopCode}
                    content={<MerchantTableBadge label={props.currentInfo.shopCode} status='neutralLight' />}
                  />
                  <DataRow
                    full
                    label={formattedMessage.terminalLabel}
                    content={<MerchantTableBadge label={props.currentInfo.terminal} status='neutralLight' />}
                  />
                  <DataRow
                    full
                    label={formattedMessage.vatLabel}
                    content={
                      props.currentInfo.vatNumber
                        ? props.currentInfo.vatNumber
                        : props.currentInfo.fiscalCode
                          ? props.currentInfo.fiscalCode
                          : ''
                    }
                  />
                </div>
                <div className='callUsContactNumbers'>
                  <p className='callUsContactLabel'>{formattedMessage.contactLabel}</p>
                  <p className='callUsContactNumber'>{supportNumber}</p>
                  <div className='callUcContacts uci'>
                    <p>{formattedMessage.contactHoursAuto}</p>
                    <p>{formattedMessage.contactHoursOperator}</p>
                    <p>{formattedMessage.contactHoursOperatorInfo}</p>
                  </div>
                </div>
              </div>
              )
        }
      </MerchantModal>
    </Toggle>
  )
}

CallUsModal.propTypes = {
  actions: PropTypes.object,
  currentInfo: PropTypes.object
}

CallUsModal.defaultProps = {
  actions: {},
  currentInfo: {}
}

export default CallUsModal
